// AppNotification
// ***********************************************************************************************************************
import { useSnackbar } from "notistack";
import * as React from "react";
import { ISignalrNotification } from "ui/Scripts/source/models/common/signalrNotification";

export interface IAppNotificationProp {
  classes?: string;
  item: ISignalrNotification;
  onClick?: () => void;
  onCloseClick?: () => void;
}

export const AppNotification = (props: IAppNotificationProp) => {
    const { enqueueSnackbar } = useSnackbar();

    React.useEffect(() => {
        enqueueSnackbar(
            {
                message: props.item.body,
                key: props.item.id,
                instantMessage: props.item,
                onCloseClick: props.onCloseClick,
            }
        );
    }, [props.item]);

    return <></>;
};
